import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';
import { DEFAULT_ORDER_BY } from 'src/constants';

export const GET_CONTRACTS = '@contracts/get-contracts';
export const REQUEST_CONTRACTS = '@contracts/request-contracts';

export function getContracts(page = 1, pagesize = 25, orderby = 'valid_from', orderdirection = DEFAULT_ORDER_BY, filter = null) {
  const params = {
    page,
    orderby,
    orderdirection
  };

  if (pagesize > 0) {
    params.pagesize = pagesize;
  }

  if (filter != null) {
    if (filter.valid != null && filter.valid != '') {
      params.valid = filter.valid;
    }
  }

  const request = axios.get(`${API_BASE_URL}/contracts`, { params });

  return (dispatch) => {
    dispatch({ type: REQUEST_CONTRACTS });

    request
      .then((response) =>
        dispatch({
          type: GET_CONTRACTS,
          payload: {
            contracts: response.data.data,
            total: response.data.total
          }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_CONTRACTS,
          payload: { contracts: [], total: 0, message }
        });
      });
  };
}
